/**
 * Formats coordinates to a string with cardinal directions (e.g., "61.4978°N / 23.7610°E")
 * @param lat Latitude in decimal degrees
 * @param lng Longitude in decimal degrees
 * @param precision Number of decimal places (default: 4)
 * @returns Formatted coordinate string
 */
export function formatCoordinates(lat: number, lng: number, precision: number = 4): string {
    const latDir = lat >= 0 ? 'N' : 'S';
    const lngDir = lng >= 0 ? 'E' : 'W';

    const absLat = Math.abs(lat).toFixed(precision);
    const absLng = Math.abs(lng).toFixed(precision);

    return `${absLat}°${latDir} / ${absLng}°${lngDir}`;
}
